<template>
  <div class="popover bs-popover-bottom">
    <div class="arrow"></div>
    <div class="popover-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popover",
};
</script>

<style lang="scss">
.popover {
  position: absolute;
  padding: 8px;
  top: 40px;
  right: 0;
  z-index: 1060;
  display: block;
  width: 200px;
  font-size: 12px;
  color: $normalTextColor;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;

  .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 0.3rem;
  }

  .arrow::before, .arrow::after {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid;
  }
}

.bs-popover-bottom {
  & > .arrow {
    right: 2px;
    top: calc(-0.5rem - 1px);
  }

  & > .arrow::before {
    top: 0;
    border-width: 0 0.5rem 0.5rem 0.5rem;
    border-bottom-color: rgba(0, 0, 0, 0.25);
  }

  & > .arrow::after {
    top: 1px;
    border-width: 0 0.5rem 0.5rem 0.5rem;
    border-bottom-color: #fff;
  }
}
</style>
